import {
  ActionArm,
  ActionBrake,
  ActionDisarm,
  ActionGoto,
  ActionManualControl,
  ActionReturn,
  ActionStickControl,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
} from '@/define/commandSet/mavlink';

const commandGroups = [
  {
    name: 'Action',
    commands: [ActionArm, ActionDisarm, ActionGoto, ActionManualControl, ActionStickControl, ActionBrake, ActionReturn],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default commandGroups;
